import React from "react";
import "./Footer.css";
import FeedbackDialog from "./FeedbackDialog";

const Footer = ({ openDialog, setOpenDialog }) => {
  return (
    <div>
      <footer className="footer-container">
        <div className="footer-external-links">
          <div className="footer-content footer-links">
            <a
              href="https://lawnetv3.pnmb.com.my/#subscription"
              target="_blank"
              rel="noopener noreferrer"
            >
              Subscribe
            </a>

            <span className="divider">|</span>
            <a
              href="https://www.lawnet.com.my/home/faq"
              target="_blank"
              rel="noopener noreferrer"
            >
              FAQ
            </a>
            <span className="divider">|</span>
            <a
              href="https://lawnetv3.pnmb.com.my/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <span className="divider">|</span>
            <a
              href="https://www.lawnet.com.my/home/copyrights"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Usage
            </a>
          </div>
        </div>
        <div className="footer-content">
          <p>Copyright 2025</p>
          <p className="footer-pnmb">Percetakan Nasional Malaysia Berhad</p>
          <p>. All rights reserved</p>
          <button className="footer-button" onClick={() => setOpenDialog(true)}>
            Need help?
          </button>
        </div>
      </footer>
      <FeedbackDialog openDialog={openDialog} setOpenDialog={setOpenDialog} showEmail={false}/>
    </div>
  );
};

export default Footer;
